import styled from 'styled-components';
import palette from '@telus-uds/palette-allium/build/web/palette';
import PropTypes from 'prop-types';
import BaseBox from './BaseBox';

export const DashboardWrapper = styled(BaseBox)`
  height: 100%;
`;

export const TopbarWrapper = styled(BaseBox)`
  background: ${palette.color.purpleTelus};
  width: 100%;
  padding: 1rem 2rem;
  justify-content: space-between;
  display: flex;
  flex-direction: ${props => props.inline ? 'row' : 'column'};
  gap: ${props => props.between ? `${props.between * 0.5}rem` : '0'};
  z-index: 1000;
  position: relative;
  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`;

export const SidebarWrapper = styled(BaseBox)`
  ul {
    display: table;
    list-style: none;
  }
  ul li {
    padding-right: 20px;
    display: table-cell;
    line-height: 30px;
    font-weight: 500;
  }

  ul li a {
    text-decoration: none !important;
  }
`;

export const ContentWrapper = styled(BaseBox)`
  width: 92%;
  margin: 0 auto;
  background-color: white;
  display: flex;
  flex-direction: column;
  min-height: 900px;

  @media (max-width: 700px) {
    padding: 0;
  }
`;

export const LeftMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  display: flex;
  justify-content: start;
  flex-direction: row;
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

export const RightMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  justify-content: flex-end;
  display: flex;
  flex-direction: ${props => props.inline ? 'row' : 'column'};
  gap: ${props => props.between ? `${props.between * 0.5}rem` : '0'};
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

export const Box = styled(BaseBox)`
  width: ${props => props.width}%;
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  flex-wrap: ${props => props.flexWrap};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  padding-bottom: ${props => props.pb}px;
  padding-top: ${props => props.pt}px;
  padding-right: ${props => props.pr}px;
  padding-left: ${props => props.pl}px;
  margin-top: ${props => props.mt}px;
  margin-right: ${props => props.mr}px;

  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    justify-content: ${props => props.mdJustifyContent};
    padding: ${props => props.mdPadding};
  }
`;

export const LinkButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  margin: 0 5px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
  }
`;

export const Button = styled.button`
  border: none;
  padding: 0;
  cursor: pointer;
  color: #49166d;
  background: none;

  :hover {
    text-decoration: underline;
  }
`;

export const FormBox = styled.div`
  width: 100%;
  position: relative;
`;

export const Text = styled.span`
  color: ${props => props.color || '#2a2c2e'};
  font-size: ${props => props.fontSize || '1rem'};
  font-weight: ${props => props.fontWeight || 700};
  letter-spacing: -0.8px;
  line-height: 1.5;
  word-wrap: break-word;
`;

Text.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.number
};

export const Overlay = styled.div`
  z-index: 10001;
  background-color: #ffffff;
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -200px;
  width: 400px;
  border-style: solid;
  border-width: 1px;
  border-color: #e2e2e2;
  text-align: center;
  padding: 20px;
  display: none;
`;

export const OverlayLayer = styled.div`
  z-index: 10000;
  filter: alpha(opacity=50); /*older IE*/
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50); /* IE */
  -moz-opacity: 0.5; /*older Mozilla*/
  -khtml-opacity: 0.5; /*older Safari*/
  opacity: 0.5; /*supported by current Mozilla, Safari, and Opera*/
  background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  display: none;
`;

export const SignatureContainer = styled.div`
  max-width: 400px;
  background-color: #e4e4e4;
`;

export const NoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderButton = styled.button`
  border: none;
  padding: 2px 1rem;
  color: #fff;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  background: none;
  font-size: 16px;
  font-weight: normal;
`;

export const HeaderLinkText = styled.h2`
  font-size: 16px;
  font-weight: normal;
  color: #fff;
`;
